<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='bom-main float-left'>
      <dx-data-grid ref='refBomMainGrid'
        :data-source='customerLookup'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="거래처코드"
        :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="발주사정보"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='true'
          caption="발주사"
          data-field="거래처명"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="거래처명"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <!-- ******************************** BOM SUB ***************************-->
    <!-- ******************************** BOM SUB ***************************-->
    <!-- ******************************** BOM SUB ***************************-->
    <div class='bom-sub-tree float-left'>
      <dx-tree-list
        ref="refBomSubGrid"
        :height='gridHeight'
        :data-source="bomInfoList"
        :autoExpandAll='true'
        :show-borders="true" :showRowLines = 'true'
        :column-auto-width="true"
        :hover-state-enabled = "true"
        key-expr="seqId"
        parent-id-expr="parentSeqId"
        :selection="{ mode: 'single' }"
        :focused-row-enabled="true"
        @selectionChanged="onSelectionChangedBom"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @toolbar-preparing='onToolbarPreparingSub'
        @row-prepared="onBomRowPrepared"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <!--
        <DxEditing
          :allow-adding="false"
          :allow-updating="false"
          :allow-deleting="false"
          :use-icons="true"
          mode="row"
        />-->
        <dx-column
          :allowEditing='false'
          data-field="품번"
          caption="품번"
          :allow-sorting="true"
        />
        <dx-column
          :allowEditing='false'
          data-field="품명"
          caption="품명"
          :allow-sorting="true"
        />
        <DxColumn
          :allowEditing='true'
          caption="원수"
          data-field="수량"
          :visible='true'
          format='#,##0.00'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="자재유형"
          data-field="자재유형"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          data-field="거래처명"
          caption="거래처명"
          :allow-sorting="true"
        />
        <DxColumn
          caption="공정유형"
          data-field="공정유형"
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          data-field="재질"
          caption="재질"
        />
        <DxColumn
          :allowEditing='false'
          caption="단위"
          data-field="단위"
          :visible='true'
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='false'
        >
        </DxColumn>
        <DxPaging
          :enabled="false"
          :page-size="100"
        />
        <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <template #bom-sub-tree>
            <div class="toolbar-label" style='font-size:1.2rem;margin-left:0px;'>
              <b v-if='selectedRow'>BOM (발주사: {{selectedRow.거래처명}})</b>
            </div>
        </template>
      </dx-tree-list>
    </div>
    <div style='height:0; overflow:hidden' class='float-left-hiden'>
      <dx-data-grid ref='refBomExportGrid'
        :data-source='mrpExcelExportInfo'
        height='300'
      >
        <DxExport
          :enabled="true"
          :file-name="bomTitle"
        />
        <DxColumn
          caption="품번"
          data-field="품번depth"
          width='200'
        >
        </DxColumn>
        <DxColumn
          caption="품영"
          data-field="품명"
          width='300'
        >
        </DxColumn>
        <DxColumn
          caption="수량"
          data-field="수량"
           format='#,##0.00'
        >
        </DxColumn>
        <DxColumn
          caption="품목유형"
          data-field="품목유형"
        >
          <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="자재유형"
          data-field="자재유형"
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="공정유형"
          data-field="공정유형"
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="재질"
          data-field="재질"
          width='200'
        />
        <DxColumn
          caption="단위"
          data-field="단위"
        >
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxSorting, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
import DxTreeList, { DxPaging } from 'devextreme-vue/tree-list'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      // 제품리스트
      gridHeight: null,
      selectedRow: null,
      focusedRowKey: null,
      processingTypeLookup: null,
      unitLookup: null,
      carTypeLookup: null,
      customerLookup: null,
      // BOM
      bomInfoList: [],
      tempBomInfoList: [],
      bomReportFile: 'bom',
      divisionList: null,
      selectedRowBom: null,
      nodeExpandBtn: null,
      rIndex: 1,
      mrpExcelExportInfo: null,
      bomTitle: null,
      meterialTypeLookup: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxTreeList
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }

    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.carTypeLookup = this.$store.getters.getCarType
    this.customerLookup = this.$store.getters.getCustomerInfo
    console.log(this.customerLookup)

    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    // ****************** 제품 Grid ************************************
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
      this.bomReportFile = `BOM_${this.selectedRow.품명}_${this.selectedRow.품번}`
      this.resetNodeBtnCollapseRow()
      this.refreshBomList(this.selectedRow.거래처코드)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>차종</b></div>`
          }
        }
      )
    },
    // ****************** BOM Grid ************************************
    // ****************** BOM Grid ************************************
    // ****************** BOM Grid ************************************
    onBomRowPrepared (row) {
      if (row.data !== undefined && row.data.상위품번 === null) {
        this.$Q(row.rowElement).css('background-color', 'rgb(255, 255, 204)')
      }
    },
    onSelectionChangedBom (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRowBom = e.row.data
      }
    },
    onToolbarPreparingSub (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'bom-sub-tree'
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'chevrondown',
            type: 'default',
            text: '노드 확장',
            disabled: true,
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.nodeExpandBtn = args.component
            },
            onClick: (args) => {
              // // console.log(args)
              let vm = this
              if (this.nodeExpandBtn.option().text === '노드 축소') {
                this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                  vm.$refs.refBomSubGrid.instance.collapseRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장' })
              } else {
                this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                  vm.$refs.refBomSubGrid.instance.expandRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevronup', text: '노드 축소' })
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'exportxlsx',
            disabled: false,
            focusStateEnabled: true,
            onClick: (args) => {
              if (this.selectedRow === null) {
                this.$snotify.info('선택된 제품이 없습니다.')
                return
              }
              this.isLoading = true
              let array = []
              const where = this.$_.where(this.bomInfoList, { 상위품번: null })
              this.mrpExcelExportInfo = []
              for (let i = 0; i < where.length; i++) {
                array.push(this.$_sp.runNoEncodeFindProc('spFindAllBomTreeWithByTopCode', { 완제품코드: where[i].품번 }))
              }
              axios.all(array)
                .then(axios.spread((...reponse) => {
                  let tempArray = []
                  for (let j = 0; j < where.length; j++) {
                    tempArray = tempArray.concat(this.$_sp.MakeModel(reponse[j]))
                  }
                  this.mrpExcelExportInfo = tempArray
                  console.log(this.mrpExcelExportInfo)
                  this.bomTitle = `${this.selectedRow.거래처명}-BOM`
                  setTimeout(() => {
                    this.isLoading = false
                    this.$refs.refBomExportGrid.instance.exportToExcel(false)
                  }, 1000)
                }))
                .catch(error => {
                  this.isLoading = false
                  if (error.response.status === ConstDef.GENERRAL_ERROR) {
                    this.$snotify.error(error.response.data.message)
                  } else {
                    this.$snotify.error(`에러코드 : ${error.response.status}`)
                  }
                })
                /*
                .then((data) => {
                  this.mrpExcelExportInfo = this.$_sp.MakeModel(data)
                  console.log(this.mrpExcelExportInfo)
                  this.bomTitle = `${this.selectedRow.품명}-BOM`
                  setTimeout(() => {
                    this.isLoading = false
                    this.$refs.refBomExportGrid.instance.exportToExcel(false)
                  }, 1000)
                })
                */
            }
          }
        }
      )
    },
    resetNodeBtnCollapseRow () {
      // // console.log('fskfjsjflsjflj')
      this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장', disabled: false })
    },
    refreshBomList (customerCode) {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllBomForwardByCustomer', { title: 'bomForward', 거래처코드: customerCode, 대수: 1 })
        .then((data) => {
          this.bomInfoList = this.$_sp.MakeModel(data)
          this.isLoading = false
          if (this.bomInfoList.length === 0) {
            this.$snotify.info('등록된 BOM 정보가 없습니다.')
          } else {
            /*
            setTimeout(() => {
              let vm = this

              this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
                vm.$refs.refBomSubGrid.instance.expandRow(node.key)
              })
            }, 300)
           */
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    /*
    rebuildBomList (parentCode) {
      this.isLoading = true
      this.rIndex = 1
      this.$_sp.runNoEncodeFindProc('spFindAllBomByTopCode', { 최상위품번: parentCode })
        .then((data) => {
          let bomInfoList = this.$_sp.MakeModel(data)
          for (let j = 0; j < bomInfoList.length; j++) {
            if (bomInfoList[j].상위품번 === null) {
              bomInfoList[j].parentSeqId = null
              continue
            }
            let where = this.$_.findWhere(bomInfoList, { 품번: bomInfoList[j].상위품번 })
            bomInfoList[j].parentSeqId = where.seqId
          }
          this.tempBomInfoList = []
          this.searchChildBomProduct(bomInfoList)
          for (let j = 0; j < bomInfoList.length; j++) {
            this.tempBomInfoList.push(bomInfoList[j])
          }
          // this.rebuildTree(this.tempBomInfoList)
          this.isLoading = false
          this.bomInfoList = this.tempBomInfoList
          for (let i = 0; i < this.bomInfoList.length; i++) {
            console.log(`${this.bomInfoList[i].품번} ${this.bomInfoList[i].상위품번} ${this.bomInfoList[i].최상위품번} ${this.bomInfoList[i].grandNo} ${this.bomInfoList[i].seqId} ${this.bomInfoList[i].parentSeqId}`)
          }
          setTimeout(() => {
            let vm = this
            this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
              vm.$refs.refBomSubGrid.instance.expandRow(node.key)
            })
          }, 300)
        })
    },
    rebuildTree (list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].상위품번 === null) {
          list[i].parentSeqId = null
          continue
        }
        let where = this.$_.where(list, { 품번: list[i].상위품번 })
        if (where.length === 1) {
          list[i].parentSeqId = where[0].seqId
        } else {
          for (let j = 0; j < where.length; j++) {
            // console.log(`${where[j].grandNo}`)
          }

          let cWhere = this.$_.findWhere(where, { 최상위품번: list[i].최상위품번 })
          if (cWhere !== undefined) {
            list[i].parentSeqId = cWhere.seqId
          } else {
            console.log(where)
            console.log(list[i].grandNo)
          }
        }
      }
      for (let i = 0; i < list.length; i++) {
        // list[i].seqId = i + 1
        // console.log(`${list[i].품번} ${list[i].상위품번} ${list[i].최상위품번} ${list[i].grandNo} ${list[i].seqId} ${list[i].parentSeqId}` )
      }
      // console.log(list)
      this.bomInfoList = list
      setTimeout(() => {
        let vm = this
        this.$refs.refBomSubGrid.instance.forEachNode(function (node) {
          vm.$refs.refBomSubGrid.instance.expandRow(node.key)
        })
      }, 300)
    },
    */
    searchChildBomProduct (bomList) {
      let localList = null
      for (let i = 0; i < bomList.length; i++) {
        if (bomList[i].상위품번 !== null && bomList[i].품목유형 !== ConstDef.구매품) {
          let goodsType = bomList[i].품목유형
          console.log('품목유형==' + goodsType)
          localList = this.$_sp.syncFindProc(this.$Q, 'spFindAllSemiBomByTopCode', { 상위품번: bomList[i].품번, 최상위품번: bomList[i].상위품번 === null ? '' : bomList[i].상위품번 })
          console.log(localList)
          for (let j = 0; j < localList.length; j++) {
            console.log('index=' + this.rIndex)
            localList[j].seqId = `S${this.rIndex++}`
            // localList[j].parentSeqId = bomList[i].seqId
            this.tempBomInfoList.push(localList[j])
          }
          for (let j = 0; j < localList.length; j++) {
            let where = this.$_.findWhere(localList, { 품번: localList[j].상위품번 })
            if (where === undefined) {
              localList[j].parentSeqId = bomList[i].seqId
            } else {
              localList[j].parentSeqId = where.seqId
            }
          }
          // console.log(`org:${bomList[i].품번} 품번:${bomList[i].품번} 상위품번:${bomList[i].상위품번} grandNo:${bomList[i].grandNo}`)
          if (localList.length > 0) {
            // console.log('bomList[i].품번='+bomList[i].품번)
            // console.log('bomList[i].상위품번='+bomList[i].상위품번)
            if (goodsType === ConstDef.반제품) {
              this.searchChildBomProduct(localList)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.sub-content{
  .bom-main{
    width:40%;
    margin-right:2%;
    border:0px solid red;
    min-height: 500px;
  }
  .bom-sub-tree{
    width:58%;
    border:0px solid red;
    min-height: 500px;
  }
}
.temp {
  color: rgb(255, 255, 204)
}
</style>
